var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 17.3158 8.96491 22 12 22C15.0351 22 17 17.3158 17 12C17 6.68421 15.0351 2 12 2C8.96491 2 7 6.68421 7 12ZM9 12C9 7.24561 10.4386 4 12 4C13.5614 4 15 7.24561 15 12C15 16.7544 13.5614 20 12 20C10.4386 20 9 16.7544 9 12ZM3.92982 10H20.0702C20.614 10 21.0702 9.54386 21.0702 9C21.0702 8.45614 20.614 8 20.0702 8H3.92982C3.38596 8 2.92982 8.45614 2.92982 9C2.92982 9.54386 3.38596 10 3.92982 10ZM3.92982 16H20.0702C20.614 16 21.0702 15.5439 21.0702 15C21.0702 14.4561 20.614 14 20.0702 14H3.92982C3.38596 14 2.92982 14.4561 2.92982 15C2.92982 15.5439 3.38596 16 3.92982 16ZM12 20C7.45614 20 4 16.5439 4 12C4 7.45614 7.45614 4 12 4C16.5439 4 20 7.45614 20 12C20 16.5439 16.5439 20 12 20ZM12 22C17.5263 22 22 17.5263 22 12C22 6.47368 17.5263 2 12 2C6.47368 2 2 6.47368 2 12C2 17.5263 6.47368 22 12 22Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageOutlined);
export default __webpack_public_path__ + "static/media/language_outlined.00eb1bfd.svg";
export { ForwardRef as ReactComponent };